import { render, staticRenderFns } from "./BookIndex.vue?vue&type=template&id=2afb9384&scoped=true&"
import script from "./BookIndex.vue?vue&type=script&lang=js&"
export * from "./BookIndex.vue?vue&type=script&lang=js&"
import style0 from "./BookIndex.vue?vue&type=style&index=0&id=2afb9384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afb9384",
  null
  
)

export default component.exports